import React from "react";
import {ChatBubbleLeftEllipsisIcon} from "@heroicons/react/24/outline";

interface SmsButtonProps {
    number: string;   // e.g. "+15551234567"
    message: string;
    label?: string;   // button label
}

export const SmsButton: React.FC<SmsButtonProps> = ({number, message, label}) => {
    const handleClick = async () => {
        const smsHref = `sms:${encodeURIComponent(number)}?body=${encodeURIComponent(message)}`;

        // Try copying to clipboard
        let copied = false;
        try {
            if (navigator.clipboard?.writeText) {
                await navigator.clipboard.writeText(message);
                copied = true;
            }
        } catch {
            // ignore errors
        }

        // iOS hint (because it ignores body=)
        if (copied && /iPad|iPhone|iPod/.test(navigator.userAgent)) {
            // replace with your own toast/notification
            alert("Message copied. On iOS, paste into Messages if the body is empty.");
        }

        // Open the SMS app
        window.location.href = smsHref;
    };

    return (
        <button
            type="button"
            onClick={handleClick}
            className="rounded-md bg-indigo-600 p-1 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
            <ChatBubbleLeftEllipsisIcon className="h-4 w-5" aria-hidden="true"/>
        </button>
    );
};
